import { render } from "./EditWebCatalogs.vue?vue&type=template&id=0d485fe4&scoped=true"
import script from "./EditWebCatalogs.vue?vue&type=script&lang=js"
export * from "./EditWebCatalogs.vue?vue&type=script&lang=js"

import "./EditWebCatalogs.vue?vue&type=style&index=0&id=0d485fe4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d485fe4"],['__file',"src/views/WebOrders/EditWebCatalogs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0d485fe4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0d485fe4', __exports__)) {
    api.reload('0d485fe4', __exports__)
  }
  
  module.hot.accept("./EditWebCatalogs.vue?vue&type=template&id=0d485fe4&scoped=true", () => {
    api.rerender('0d485fe4', render)
  })

}


export default __exports__